import { render, staticRenderFns } from "./Total.vue?vue&type=template&id=7b2ee724&"
import script from "./Total.vue?vue&type=script&lang=ts&"
export * from "./Total.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartStockWarning: require('/app/components/cart/StockWarning.vue').default,ProductPrice: require('/app/components/product/Price.vue').default,CartSubmitButton: require('/app/components/cart/SubmitButton.vue').default,BaseOverlay: require('/app/components/base/Overlay.vue').default})
